import {FC} from "react";
import {INode} from "../../SurveyModel/types/nodeTypes";


// Define the props interface for your component
interface IProgressBreadcrumb {
  selectedNode?:  INode

}

const ProgressBreadcrumb:FC<IProgressBreadcrumb> = (peops: IProgressBreadcrumb) => {

  const {selectedNode} = peops
    return  <div className="progress-breadcrumb"> <div className="progress-container">
    <div className="progress-bar">
      <div className="step completed">
        <span className="circle">
            <span className="inner-circle"></span>
        </span>
      </div>
      <div className="step-line">
      </div>
      <div className="step">
        <span className="circle"></span>
      </div>
      <div className="step-line">
      </div>
      <div className="step">
        <span className="circle"></span>
      </div>
      <div className="step-line">
      </div>
      <div className="step">
        <span className="circle"></span>
      </div>
      <div className="step-line">
      </div>
      <div className="step">
        <span className="circle"></span>
      </div>
      <div className="step-line">
      </div>
      <div className="step">
        <span className="circle"></span>
      </div>
      <div className="step-line">
      </div>
      <div className="step">
        <span className="circle"></span>
      </div>
      <div className="step-line">
      </div>
      <div className="step">
        <span className="circle"></span>
      </div>
      <div className="step-line">
      </div>
      <div className="step">
        <span className="circle"></span>
      </div>
      <div className="step-line">
      </div>
      <div className="step">
        <span className="circle"></span>
      </div>
      <div className="step-line">
      </div>
      <div className="step">
        <span className="circle"></span>
      </div>
    </div>
  </div>
  <div className="breadcrumb">
    <div className="breadcrumb-title">{selectedNode &&  selectedNode.nodes && selectedNode.nodes[0] && selectedNode.nodes[0].title }</div>
  </div>
  </div>
};

export default ProgressBreadcrumb;